import { IInformation } from '../../../interfaces/Information.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetInformationByIdParams {
  informationId: string;
}

export const getInformationById = ({ informationId }: IGetInformationByIdParams): Promise<IInformation> => {
  return customAxios.get(`/informations/${informationId}`);
};
